"use client";

import { Tooltip as HeroTooltip } from "@heroui/react";
import { cn } from "../../lib/utils";

/** Defaults to `foreground`, the theme's inverse, so a tooltip reads dark on a light page and light on a dark one. */
export const Tooltip = ({
  className,
  color = "foreground",
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroTooltip>) => {
  return <HeroTooltip className={cn("max-w-100", className)} color={color} {...props} />;
};
